'use strict';

exports.__esModule = true;
exports.AvailableProfilesList = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvailableProfilesList = function AvailableProfilesList(props) {
	var profiles = props.profiles,
	    currentProfile = props.currentProfile,
	    isOpen = props.isOpen,
	    toggleProfileDropdown = props.toggleProfileDropdown,
	    onProfileClicked = props.onProfileClicked;

	return _react2.default.createElement(
		'li',
		{ className: '' + _style.availableProfiles },
		profiles.length <= 1 ? _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'a',
				{ href: '/' + currentProfile.type + '/' + currentProfile.uri_id + '/edit' },
				currentProfile.image && _react2.default.createElement('img', { itemProp: 'image',
					src: currentProfile.image,
					alt: 'image of ' + currentProfile.name }),
				_react2.default.createElement(
					'span',
					null,
					currentProfile.name
				)
			)
		) : _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'a',
				{ className: '' + _style.activeProfile,
					onClick: toggleProfileDropdown },
				currentProfile.image && _react2.default.createElement('img', { itemProp: 'image',
					src: currentProfile.image,
					alt: 'image of ' + currentProfile.name }) || currentProfile.specialties && _react2.default.createElement('img', { itemProp: 'image',
					src: currentProfile.specialties[0].icon_uri,
					alt: 'image of ' + currentProfile.name }),
				_react2.default.createElement(
					'span',
					null,
					currentProfile.type === 'specialist' && currentProfile.name || currentProfile.type === 'practice' && currentProfile.practice_name
				),
				_react2.default.createElement('i', { className: 'ion-ios-arrow-down' })
			),
			isOpen && _react2.default.createElement(
				'div',
				{ className: _style.availableProfilesDropdown + ' ' + _style.navDropdown + ' ' + _style.dropdownMenuContainer },
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'ul',
						null,
						profiles.map(function (profile, index) {
							return _react2.default.createElement(
								'li',
								{ key: index },
								_react2.default.createElement(
									'a',
									{ href: '/' + profile.type + '/' + profile.uri_id + '/edit/profile', onClick: function onClick() {
											return onProfileClicked(profile);
										} },
									profile.image && _react2.default.createElement('img', { itemProp: 'image',
										src: profile.image,
										alt: 'image of ' + profile.name }) || currentProfile.specialties && _react2.default.createElement('img', { itemProp: 'image',
										src: currentProfile.specialties[0].icon_uri,
										alt: 'image of ' + currentProfile.name }),
									_react2.default.createElement(
										'span',
										null,
										profile.name
									),
									profile.id === currentProfile.id && _react2.default.createElement('i', { className: 'ion-checkmark' })
								)
							);
						})
					)
				)
			)
		)
	);
};

AvailableProfilesList.propTypes = {
	profiles: require('react').PropTypes.arrayOf(require('react').PropTypes.any).isRequired,
	currentProfile: require('react').PropTypes.any.isRequired,
	isOpen: require('react').PropTypes.bool.isRequired,
	toggleProfileDropdown: require('react').PropTypes.func.isRequired,
	onProfileClicked: require('react').PropTypes.func.isRequired
};
AvailableProfilesList.defaultProps = {
	profiles: [],
	currentProfile: {},
	isOpen: false,
	toggleProfileDropdown: function toggleProfileDropdown() {},
	onProfileClicked: function onProfileClicked() {}
};

exports.AvailableProfilesList = AvailableProfilesList;


// WEBPACK FOOTER //
// ./components/top-nav/lib/components/available-profiles-list.js